import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  pageWrapper: {
    display: "flex",
    gap: 24,
    padding: "24px 0",
    alignItems: "flex-start",
  },

  // ── Tab bar ──────────────────────────────────────────────────────────────
  tabBar: {
    borderBottom: "1px solid #E5E5E5",
    marginBottom: 0,
    "& .mantine-Tabs-tabsList": {
      borderBottom: "none",
      flexWrap: "nowrap",
    },
    "& .mantine-Tabs-tab": {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 600,
      color: "#737373",
      paddingBottom: 14,
      paddingTop: 0,
      paddingLeft: 14,
      paddingRight: 14,
      borderBottom: "2px solid transparent",
      borderRadius: 0,
      "&[data-active]": {
        color: "#171717",
        borderBottomColor: "#171717",
      },
      "&:hover": {
        background: "transparent",
        color: "#171717",
      },
    },
  },

  // ── Main card ─────────────────────────────────────────────────────────────
  card: {
    background: "#fff",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    overflow: "hidden",
  },

  // ── Card header ───────────────────────────────────────────────────────────
  cardHeader: {
    padding: "20px 24px",
    borderBottom: "1px solid #F2F2F2",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
  },
  cardHeaderLeft: {
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
  },
  cardIconWrap: {
    width: 44,
    height: 44,
    background: "#FFF3DC",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardTitle: {
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 700,
    color: "#171717",
    lineHeight: "27px",
    marginBottom: 4,
  },
  cardDesc: {
    fontFamily: "Inter",
    fontSize: 13.5,
    fontWeight: 400,
    color: "#737373",
    lineHeight: "20.25px",
  },

  previewBtn: {
    height: 38,
    borderRadius: 8,
    border: "1px solid #D4D4D4",
    background: "#fff",
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    color: "#171717",
    padding: "0 16px",
    flexShrink: 0,
    "&:hover": {
      background: "#F5F5F5",
    },
  },

  // ── Row ───────────────────────────────────────────────────────────────────
  row: {
    padding: "19px 24px",
    borderTop: "1px solid #F2F2F2",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
  },
  rowLabel: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 600,
    color: "#171717",
    lineHeight: "21px",
    marginBottom: 2,
  },
  rowSub: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 400,
    color: "#737373",
    lineHeight: "19.5px",
  },
  rowRight: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexShrink: 0,
  },

  // ── Toggle ────────────────────────────────────────────────────────────────
  toggleTrack: {
    "& .mantine-Switch-track": {
      width: 44,
      minWidth: 44,
      height: 26,
      borderRadius: 999,
      border: "none",
      cursor: "pointer",
      backgroundColor: "#D4D4D4",
    },
    "& input:checked + * > .mantine-Switch-track, & input:checked ~ .mantine-Switch-track":
      {
        backgroundColor: "#171717 !important",
      },
    "& .mantine-Switch-thumb": {
      width: 20,
      height: 20,
      border: "none",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.15)",
    },
  },

  // ── Dropdowns ─────────────────────────────────────────────────────────────
  selectInput: {
    "& .mantine-Select-input": {
      height: 36,
      borderRadius: 8,
      border: "1px solid #D4D4D4",
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: 500,
      color: "#171717",
      paddingLeft: 13,
    },
  },

  // ── Segmented control ─────────────────────────────────────────────────────
  segmented: {
    background: "#F5F5F5",
    border: "1px solid #E5E5E5",
    borderRadius: 8,
    padding: 4,
    "& .mantine-SegmentedControl-label": {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: 600,
      color: "#737373",
      padding: "6px 12px",
    },
    "& .mantine-SegmentedControl-active .mantine-SegmentedControl-label": {
      color: "#171717",
    },
    "& .mantine-SegmentedControl-indicator": {
      background: "#fff",
      boxShadow: "0px 1px 2px rgba(16,24,40,0.06)",
      borderRadius: 6,
    },
  },

  // ── Sections block ────────────────────────────────────────────────────────
  sectionsRow: {
    padding: "21px 24px 24px",
    borderTop: "1px solid #F2F2F2",
  },
  sectionLabel: {
    fontFamily: "Inter",
    fontSize: 11,
    fontWeight: 600,
    color: "#737373",
    textTransform: "uppercase",
    letterSpacing: "0.66px",
    lineHeight: "16.5px",
    marginBottom: 4,
  },
  sectionSubLabel: {
    fontFamily: "Inter",
    fontSize: 13.5,
    fontWeight: 400,
    color: "#525252",
    lineHeight: "20.25px",
    marginBottom: 16,
  },
  sectionCard: {
    background: "#fff",
    borderRadius: 10,
    border: "1px solid #E5E5E5",
    padding: 15,
    marginBottom: 8,
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
  },
  sectionCheckbox: {
    "& .mantine-Checkbox-input:checked": {
      background: "#171717",
      borderColor: "#171717",
    },
    "& .mantine-Checkbox-input": {
      borderRadius: 5,
      width: 20,
      height: 20,
      cursor: "pointer",
    },
  },
  sectionCardBody: {
    flex: 1,
  },
  sectionCardTitle: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 600,
    color: "#171717",
    lineHeight: "21px",
    marginBottom: 2,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  sectionCardDesc: {
    fontFamily: "Inter",
    fontSize: 12.5,
    fontWeight: 400,
    color: "#737373",
    lineHeight: "18.75px",
    marginBottom: 8,
  },
  examplePill: {
    background: "#FAFAFA",
    border: "1px solid #E5E5E5",
    borderRadius: 6,
    padding: "9px 11px",
    display: "inline-flex",
    alignItems: "center",
    fontFamily: "Inter",
    fontSize: 11.5,
    lineHeight: "17.25px",
  },
  exampleLabel: {
    fontFamily: "Inter",
    fontSize: 11.5,
    fontWeight: 400,
    color: "#525252",
    lineHeight: "17.25px",
  },
  exampleValue: {
    fontFamily: "Inter",
    fontSize: 11.5,
    fontWeight: 600,
    color: "#171717",
    lineHeight: "17.25px",
  },
  requiresBadge: {
    background: "#EFF8FF",
    borderRadius: 999,
    padding: "3px 8px",
    fontFamily: "Inter",
    fontSize: 10.5,
    fontWeight: 600,
    color: "#175CD3",
    lineHeight: "15.75px",
    whiteSpace: "nowrap",
  },

  // ── Recipients ────────────────────────────────────────────────────────────
  recipientsRow: {
    padding: "21px 24px 24px",
    borderTop: "1px solid #F2F2F2",
  },
  recipientsHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  recipientsTitle: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 600,
    color: "#171717",
    lineHeight: "21px",
  },
  manageLink: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    color: "#171717",
    lineHeight: "19.5px",
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },
  recipientsDesc: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 400,
    color: "#737373",
    lineHeight: "19.5px",
    marginBottom: 14,
  },
  recipientsDescBold: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 700,
    color: "#404040",
    lineHeight: "19.5px",
  },
  recipientPills: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
  },
  recipientPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    background: "#FAFAFA",
    border: "1px solid #E5E5E5",
    borderRadius: 999,
    padding: "7px 15px 7px 7px",
    fontFamily: "Inter",
    fontSize: 12.5,
    fontWeight: 500,
    color: "#171717",
    lineHeight: "18.75px",
  },
  recipientAvatar: {
    width: 24,
    height: 24,
    borderRadius: 12,
    background: "#FFF3DC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Inter",
    fontSize: 11,
    fontWeight: 700,
    color: "#7A271A",
    flexShrink: 0,
  },

  // ── Footer bar ────────────────────────────────────────────────────────────
  cardFooter: {
    background: "#FAFAFA",
    borderTop: "1px solid #F2F2F2",
    padding: "17px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: 16,
  },
  learnLink: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 400,
    color: "#737373",
    cursor: "pointer",
    textDecoration: "none",
  },
  footerBtns: {
    display: "flex",
    gap: 8,
  },
  testBtn: {
    height: 38,
    borderRadius: 8,
    border: "1px solid #D4D4D4",
    background: "#fff",
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    color: "#171717",
    padding: "0 16px",
    "&:hover": { background: "#F5F5F5" },
  },
  saveBtn: {
    height: 38,
    borderRadius: 8,
    border: "1px solid #FFBA45",
    background: "#FFBA45",
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    color: "#171717",
    padding: "0 20px",
    "&:hover": { opacity: 0.85 },
  },

  // ── Disabled overlay ──────────────────────────────────────────────────────
  disabledSection: {
    position: "relative",
  },
  disabledOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(255,255,255,0.65)",
    borderRadius: 12,
    zIndex: 2,
    pointerEvents: "all",
    cursor: "not-allowed",
  },

  // ── Preview Modal ─────────────────────────────────────────────────────────
  previewModal: {
    "& .mantine-Modal-content": {
      borderRadius: 12,
      overflow: "hidden",
    },
    "& .mantine-Modal-header": {
      padding: "16px 20px",
      borderBottom: "1px solid #E5E5E5",
    },
    "& .mantine-Modal-title": {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: 600,
      color: "#171717",
    },
    "& .mantine-Modal-body": {
      padding: 0,
    },
  },
  previewIframeWrap: {
    height: "75vh",
    overflow: "hidden",
  },
  previewIframe: {
    width: "100%",
    height: "100%",
    border: "none",
    display: "block",
  },

  // ── Info banner ───────────────────────────────────────────────────────────
  infoBanner: {
    background: "#fff",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    padding: "18px 24px",
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    marginTop: 16,
  },
  infoBannerIcon: {
    width: 36,
    height: 36,
    background: "#EFF8FF",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  infoBannerText: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 400,
    color: "#525252",
    lineHeight: "19.5px",
  },
  infoBannerBold: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 700,
    color: "#171717",
    lineHeight: "19.5px",
  },
  infoBannerLink: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    color: "#171717",
    lineHeight: "19.5px",
    textDecoration: "underline",
    cursor: "pointer",
  },
}));

export default useStyles;
